module.exports = __webpack_public_path__ + "img/deferredExchange1.edd484ce.png";